var _filter, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorGrabbed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 21 20",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 14.1254,
    width: 15.173,
    x: 2.75493,
    y: 3.99512
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_1_10007"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_10007",
    mode: "normal",
    result: "shape"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.50003 5.14995c.48-.18 1.43-.07 1.68.47s.4 1.24.41 1.07c-.01914-.5167.02452-1.03382.13-1.54.11114-.32418.36581-.57885.69-.69.29731-.09403.61297-.11462.91997-.06.3104.0639.5854.24243.77.5.234.58313.3659 1.20215.39 1.83.0249-.53574.1156-1.0664.27-1.58.1671-.23545.4112-.40521.69-.48.3306-.06044.6694-.06044 1 0 .2714.09006.5087.26106.68.49.2124.53015.3406 1.09025.38 1.66 0 .14.07-.39.29-.74.1768-.52467.7454-.80673 1.27-.63.5247.17673.8068.74533.63 1.27v1.06 1.2c-.036.58522-.1162 1.16685-.24 1.74005-.1735.5073-.4158.9884-.72 1.43-.4854.54-.8866 1.1502-1.19 1.81-.074.328-.1076.6638-.1 1-.001.3106.0394.62.12.92-.4088.0436-.8211.0436-1.23 0-.39-.06-.87-.84-1-1.08-.0643-.1289-.1959-.2103-.34-.2103-.144 0-.2757.0814-.34.2103-.22.38-.71 1.07-1 1.11-.66997.08-2.05997 0-3.13997 0 0 0 .19-1-.23-1.36s-.83-.7801-1.14-1.06l-.83-.92c-.58531-.5434-1.01362-1.2342-1.24-2-.21-.94005-.19-1.39005 0-1.77005.19378-.31379.49639-.5452.85-.65.29377-.05329.59618-.03267.88.06.19626.08217.36589.21717.49.39.23.31.31.46.21.12s-.32-.59-.43-1c-.21415-.4842-.34272-1.00187-.38-1.53.04098-.47383.37182-.87244.83-1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m6.50003 5.14995c.48-.18 1.43-.07 1.68.47s.4 1.24.41 1.07c-.01914-.5167.02452-1.03382.13-1.54.11114-.32418.36581-.57885.69-.69.29731-.09403.61297-.11462.91997-.06.3104.0639.5854.24243.77.5.234.58313.3659 1.20215.39 1.83.0249-.53574.1156-1.0664.27-1.58.1671-.23545.4112-.40521.69-.48.3306-.06044.6694-.06044 1 0 .2714.09006.5087.26106.68.49.2124.53015.3406 1.09025.38 1.66 0 .14.07-.39.29-.74.1768-.52467.7454-.80673 1.27-.63.5247.17673.8068.74533.63 1.27v1.06 1.2c-.036.58522-.1162 1.16685-.24 1.74005-.1735.5073-.4158.9884-.72 1.43-.4854.54-.8866 1.1502-1.19 1.81-.074.328-.1076.6638-.1 1-.001.3106.0394.62.12.92-.4088.0436-.8211.0436-1.23 0-.39-.06-.87-.84-1-1.08-.0643-.1289-.1959-.2103-.34-.2103-.144 0-.2757.0814-.34.2103-.22.38-.71 1.07-1 1.11-.66997.08-2.05997 0-3.13997 0 0 0 .19-1-.23-1.36s-.83-.78-1.14-1.06l-.83-.92c-.58531-.5434-1.01362-1.2342-1.24-2-.21-.94005-.19-1.39005 0-1.77005.19378-.31379.49639-.5452.85-.65.29377-.05329.59618-.03267.88.06.19626.08217.36589.21717.49.39.23.31.31.46.21.12s-.32-.59-.43-1c-.21415-.4842-.34272-1.00187-.38-1.53.02044-.48076.34056-.89692.8-1.04z",
    fillRule: "evenodd",
    stroke: "#222124",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#222124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.25 12.8259v-3.45179c0-.20662-.1679-.37411-.375-.37411s-.375.16749-.375.37411v3.45179c0 .2066.1679.3741.375.3741s.375-.1675.375-.3741z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.27 12.8246-.02-3.45353c-.0012-.20612-.1701-.37225-.3772-.37106-.2071.00118-.374.16924-.3728.37536l.02 3.45353c.0012.2061.1701.3723.3772.3711s.374-.1693.3728-.3754z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.50001 9.37991.02 3.44459c.00121.2086.17008.3767.37718.3755.20711-.0012.37401-.1713.37281-.3799l-.02-3.44461c-.0012-.20859-.1701-.3767-.37719-.37548-.20711.00122-.37401.1713-.3728.3799z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorGrabbed);
export default __webpack_public_path__ + "static/media/cursor-grabbed.86d95c38783a4db039a6bd6694c714f7.svg";
export { ForwardRef as ReactComponent };